import { keyframes } from '@angular/animations';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ObjectDiffService {

  constructor() { }

diff(obj1: Object, obj2: Object, properties?: string[]) {
    let result = [];
    let objWithMostKeys=Object.keys(obj1).length>=Object.keys(obj2).length?obj1:obj2;
    Object.keys(objWithMostKeys).forEach(key => {
      if (!properties || properties && properties.indexOf(key) != -1) {
        if (obj1[key] != obj2[key]) {
          result.push({ property: key, from: obj1[key]==undefined?null:obj1[key], to: obj2[key]==undefined?null:obj2[key]});
        }
      }
    })
    return result;
  }

}
